import {
    Button,
    ButtonGroup,
    DialogTitle,
    DialogContent,
    Grid, FormControlLabel, Radio,
    DialogActions,
    Typography,
} from "@material-ui/core";
import { useAlert } from "react-alert";
import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import { useState } from 'react';

/* 
    | START TIME | END TIME |
    ------------------------
    Days:     M T W T F S S
    -----------------------
    startsOn:  <Day>
    ends: NEVER?
    endsOn: 

    [cancel]        [add]
*/

const getDefaultData = () => {
    const startDate = new Date();
    const startTime = new Date();
    startTime.setHours(9, 0);
    const endTime = new Date();
    endTime.setHours(17, 0);

    return {
        startDate,
        endDate: null,
        startTime,
        endTime,
        recurringDays: [],
        endingType: 'ends-never',
    }
}


const formatDates = (data) => {
    if (data == null)
        return data;
    data = JSON.parse(JSON.stringify(data))
    // push the time forward? by UsersTimeZoneValue for displaying
    if (data.startTime != null) {
        const tempDate = new Date(data.startTime)
        // data.startTime = new Date(tempDate.getTime() + tempDate.getTimezoneOffset() * 60000)
        data.startTime = new Date(tempDate.getTime())
        data.startTime = new Date(data.startTime.setMinutes(data.startTime.getMinutes() + data.startTime.getTimezoneOffset()))
        console.log(tempDate, data.startTime)
    }
    if (data.endTime != null) {
        const tempDate = new Date(data.endTime)
        // data.endTime = new Date(tempDate.getTime() + tempDate.getTimezoneOffset() * 60000)
        data.endTime = new Date(tempDate.getTime())
        data.endTime = new Date(data.endTime.setMinutes(data.endTime.getMinutes() + data.endTime.getTimezoneOffset()))
        
    }

    console.log("Formatted", data);
    return data;
}

const normalizeDate = (date) => {
    if (date == null)
        return date;
    let temp_date = new Date(date.getTime())
    temp_date = new Date(temp_date.setMinutes(temp_date.getMinutes() - temp_date.getTimezoneOffset()))
    // return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    return temp_date
}

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export default function AddOpeningHourComponent({ data, onUpdate, onClose }) {
    const alert = useAlert();
    const [slot, setSlot] = useState(formatDates(data) || getDefaultData());
    const toggleDay = (day) => {
        const updated = [...slot.recurringDays];
        const index = updated.indexOf(day);
        if (index > -1) {
            updated.splice(index, 1);
        } else {
            updated.push(day);
        }
        setSlot({ ...slot, recurringDays: updated })
    }

    const onAdd = () => {
        // validate
        if (slot.startDate === null) {
            alert.show("Start date must be set");
            return;
        }
        if (slot.recurringDays.length === 0) {
            alert.show("Must select atleast one day");
            return;
        }

        if (slot.endingType === 'ends-on' && slot.endDate === null) {
            alert.show("End date must be set")
            return;
        }

        // push backward by users timeZoneValue
        onUpdate({
            ...slot,
            startTime: normalizeDate(slot.startTime),
            endTime: normalizeDate(slot.endTime),
        });
    }

    const isDayActive = (day) => {
        return slot.recurringDays?.includes(day);
    }

    const WeekToggleButtons = () => {
        const buttons = DAYS.map(day => {
            return (
                <Button onClick={() => toggleDay(day)}
                    color={isDayActive(day) ? 'primary' : ''}
                    key={day}
                    variant="contained"
                    disableElevation
                >
                    {day[0]}
                </Button>
            );
        });
        return (<ButtonGroup size="small">{buttons}</ButtonGroup>);
    }

    return (
        <>
            <DialogTitle id="form-dialog-title">Add Opening hour</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12} style={{ marginBottom: '16px' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <KeyboardTimePicker
                                    label="Start time"
                                    value={slot.startTime} onChange={(startTime) => setSlot((slot) => ({ ...slot, startTime }))}
                                    inputVariant="outlined"
                                    fullWidth
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardTimePicker
                                    label="End time"
                                    value={slot.endTime} onChange={(endTime) => setSlot((slot) => ({ ...slot, endTime }))}
                                    inputVariant="outlined"
                                    fullWidth
                                />

                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} style={{ marginBottom: '16px' }}>
                        <Grid container>
                            <Grid item style={{ flex: '1' }}><Typography>Repeats on</Typography></Grid>
                            <Grid item>
                                {WeekToggleButtons()}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '16px', marginTop: 8 }}>
                        <KeyboardDatePicker
                            label="Start date"
                            value={slot.start} onChange={(start) => setSlot((slot) => ({ ...slot, start }))}
                            inputVariant="outlined"
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            Ends
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel value="end" control={
                            <Radio color="primary" checked={slot.endingType === 'ends-never'} onChange={() => setSlot((slot) => ({ ...slot, endingType: 'ends-never' }))} />
                        } label="Never" />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="center" alignItems="center">
                            <Grid item xs={6}>
                                <FormControlLabel value="end" control={
                                    <Radio color="primary" checked={slot.endingType === 'ends-on'} onChange={() => setSlot((slot) => ({ ...slot, endingType: 'ends-on' }))} />
                                } label="On" />
                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardDatePicker
                                    inputVariant="outlined"
                                    variant="dialog"
                                    format="dd/MM/yyyy"
                                    disabled={slot.endingType !== 'ends-on'}
                                    style={{ marginRight: '8px' }}
                                    margin="dense"
                                    value={slot.endDate}
                                    onChange={(endDate) => setSlot((slot) => ({ ...slot, endDate }))}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button onClick={onAdd} color="primary">ADD</Button>
            </DialogActions>
        </>
    )
}
